import { Banner as Banner$1 } from '@shopify/ui-extensions/checkout';
import { createRemoteReactComponent } from '@remote-ui/react';

const Banner = createRemoteReactComponent(Banner$1);

export { Banner };
